import React from 'react';
import { format } from 'date-fns';
import { formatTableLabel, getFormatDate } from './MortgageRateTrends.utils.js';

var formatDate = getFormatDate(format);
var RateHistoryTable = function RateHistoryTable(_ref) {
  var program = _ref.program,
    stateAbbreviation = _ref.stateAbbreviation,
    creditScoreBucket = _ref.creditScoreBucket,
    loanAmountBucket = _ref.loanAmountBucket,
    loanToValueBucket = _ref.loanToValueBucket,
    samples = _ref.samples,
    refinance = _ref.refinance,
    durationDays = _ref.durationDays;
  return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("caption", null, formatTableLabel({
    stateAbbreviation: stateAbbreviation,
    durationDays: durationDays,
    loanAmountBucket: loanAmountBucket,
    loanToValueBucket: loanToValueBucket,
    creditScoreBucket: creditScoreBucket,
    program: program,
    refinance: refinance
  })), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Date & Time;"), /*#__PURE__*/React.createElement("th", null, "Percent Interest Rate;"), /*#__PURE__*/React.createElement("th", null, "Annual Percentage Rate;"))), /*#__PURE__*/React.createElement("tbody", null, samples === null || samples === void 0 ? void 0 : samples.map(function (_ref2) {
    var apr = _ref2.apr,
      rate = _ref2.rate,
      time = _ref2.time;
    return /*#__PURE__*/React.createElement("tr", {
      key: formatDate(time, durationDays)
    }, /*#__PURE__*/React.createElement("th", null, "on " + formatDate(time, durationDays)), /*#__PURE__*/React.createElement("td", null, "the rate was " + rate + " percent,"), /*#__PURE__*/React.createElement("td", null, "and the annual percentage rate was " + apr + " percent."));
  })));
};
var RateHistoryTable$1 = RateHistoryTable;

export { RateHistoryTable$1 as default };
